import { Injectable } from '@angular/core';
import { WancomHttpService } from '../wancom-http/wancom-http.service';
import { FaceTimeWork } from './faceTimeWork.model';

@Injectable({
	providedIn: 'root',
})
export class FaceTimeWorkService {
	public url: string = 'faces/';

	constructor(protected http: WancomHttpService) {}

	getFaceTimeWorks(faceId: number) {
		return this.http.get<FaceTimeWork[]>(
			`${this.url}getFaceTimeWorks/${faceId}`
		);
	}

	setFaceTimeWorks(faceId: number, newTimers: FaceTimeWork[]) {
		return this.http.post(`${this.url}setFaceTimeWorks/${faceId}`, newTimers);
	}
}
